import Navbar from "../../Navbar";
import { UrlApi } from "../../../services/apirest";
import { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  TextField,
  Paper,
  Grid,
  MenuItem,
} from "@mui/material";
import moment from "moment";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import NotAllow from "../notAllow/NotAllow";
import { logEventos } from "../../../services/services";
function Etiquetas() {
  const [type, setType] = useState("Etiquetas");
  const [etiquetas, setEtiquetas] = useState([]);
  const [datosConsulta, setDatosconsulta] = useState({
    idSucursal: 8,
    fechainicio: moment().format("YYYY-MM-DD"),
  });

  const handleChangeType = (e) => {
    setType(e.target.value);
  };

  function almacenar(e) {
    setDatosconsulta({
      ...datosConsulta,
      [e.target.name]: e.target.value,
    });
  }

  // FUNCIONES PARA CONSULTAR LAS ETIQUETAS
  const imprimirEtiquetas = async (e) => {
    e.preventDefault();
    const fechaHoy = moment().format("YYYY-MM-DD");
    const { fecha, idSucursal } = datosConsulta;
    try {
      const response = await fetch(
        `${UrlApi}/viandas/pedidos/etiquetasPDF?fecha=${
          fecha ? fecha : fechaHoy
        }&idSucursal=${idSucursal}&type=${type ? type : "Etiquetas"}`
      );

      if (!response.ok) throw new Error("No se pudo generar el PDF");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Abrir en nueva pestaña
      const nuevaPestana = window.open(url, "_blank");

      // Esperar un poco y abrir impresión automáticamente
      if (nuevaPestana) {
        nuevaPestana.focus();
        nuevaPestana.onload = () => {
          nuevaPestana.print(); // Esto a veces necesita interacción directa del usuario
        };
      } else {
        alert(
          "El navegador bloqueó la nueva pestaña. Permitilo para imprimir."
        );
      }

      // Liberar la URL
      setTimeout(() => window.URL.revokeObjectURL(url), 5000);
    } catch (err) {
      console.error(`ERROR AL GENERAR EL PDF: ${err}`);
    }
  };

  useEffect(() => {
  logEventos(
  "acceso al menú Viandas Etiquetas",
   "Viandas", 
   "imprimir  Etiquetas", 
   localStorage.getItem("user"));
}, []);
  return (
    <>
      <Navbar />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "90vh",
          bgcolor: "#f4f4f4",
          p: 2,
        }}
      >
        <Paper
          elevation={6}
          sx={{
            width: "100%",
            maxWidth: 500,
            p: 4,
            borderRadius: 4,
            background: "linear-gradient(135deg, #ffffff, #ffe3df)",
            boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
          }}
        >
          <Typography
            variant="h5"
            align="center"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#3e3e3e" }}
          >
            Imprimir etiquetas
          </Typography>

          <TextField
            id="type"
            label="Tipo de etiqueta"
            select
            value={type}
            onChange={handleChangeType}
            fullWidth
            margin="normal"
            sx={{ mt: 2 }}
          >
            <MenuItem value="A4">A4</MenuItem>
            <MenuItem value="Etiquetas">Etiquetas</MenuItem>
          </TextField>

          <TextField
            fullWidth
            type="date"
            name="fecha"
            label="Fecha"
            onChange={almacenar}
            value={moment(datosConsulta.fecha).format("YYYY-MM-DD")}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />

          <Button
            variant="contained"
            fullWidth
            startIcon={<PictureAsPdfIcon />}
            onClick={imprimirEtiquetas}
            sx={{
              mt: 3,
              py: 1.5,
              fontWeight: "bold",
              fontSize: "1rem",
              bgcolor: "#d32f2f",
              color: "white",
              "&:hover": {
                bgcolor: "#9a0007",
              },
            }}
          >
            Imprimir PDF
          </Button>
        </Paper>
      </Box>
    </>
  );
}
export default Etiquetas;